import type { StoreName } from '~/types/Store';

export const ONBOARDING_2024_ROUTES = {
  plan: '/onboarding/plan',
  connectStore: '/onboarding/connect_store',
} as const;

export type Onboarding204RouteType =
  (typeof ONBOARDING_2024_ROUTES)[keyof typeof ONBOARDING_2024_ROUTES];

export const ONBOARDING_2024_PLANS = {
  starter: 'PAYG-Standard',
  developer: 'PAYG-Developer',
  pro: 'PRO',
} as const;

export type Onboarding2024PlanType =
  (typeof ONBOARDING_2024_PLANS)[keyof typeof ONBOARDING_2024_PLANS];

export const ONBOARDING_2024_ORDER_IMPORT_METHODS = {
  manual: 'manual',
  csvImport: 'csv_import',
} as const;

export type Onboarding204OrderImportMethodType =
  (typeof ONBOARDING_2024_ORDER_IMPORT_METHODS)[keyof typeof ONBOARDING_2024_ORDER_IMPORT_METHODS];

type PaygFormat = `PAYG ${string} ${string} ${string}`;
type ProFormat = `Pro ${string}`;
type PlanCode = PaygFormat | ProFormat;

export type Plan = {
  id: Onboarding2024PlanType;
  planCode: PlanCode;
  title: string;
  pricing: string;
  description: string;
  features: string[];
  icon: React.ImgHTMLAttributes<HTMLImageElement>['src'];
};

export const ONBOARDING_2024_STEP_NAMES = {
  plan: '2024onboarding.ChoosePlan',
  connectStore: '2024onboarding.AddOrders',
} as const;

export type Onboarding2024StepName =
  (typeof ONBOARDING_2024_STEP_NAMES)[keyof typeof ONBOARDING_2024_STEP_NAMES];

export type OnboardingStepCompleted = {
  is2024_signup_flow?: boolean;
  current_step_name?: string;
  current_step_index?: number;
  last_completed_step_index?: number | null;
  last_completed_step_name?: string | null;
  store_connection_started?: StoreName | 'Manual Order' | 'CSV Upload';
};
